import i18n from 'i18next';

import { TopMarketRequestsType } from '../constants';

export const getMarketRequestsTextValues = (type: TopMarketRequestsType) => {
  switch (type) {
    case TopMarketRequestsType.DOMAINS:
      return {
        sectionTitle: i18n.t('Domains'),
        tableTitle: i18n.t('Top 20'),
        tooltipText: i18n.t(
          'Based on the deal’s targeting and past performance, these Domains are expected to have the highest volume.'
        ),
        valuesColumnTitle: i18n.t('Market requests'),
      };
    case TopMarketRequestsType.BUNDLES:
      return {
        sectionTitle: i18n.t('Bundle IDs'),
        tableTitle: i18n.t('Top 20'),
        tooltipText: i18n.t(
          'Based on the deal’s targeting and past performance, these Bundle IDs are expected to have the highest volume.'
        ),
        valuesColumnTitle: i18n.t('Market requests'),
      };
  }
};
